export const BASE_REPORT_FLOW = [
    {
      id: "why",
      type: "list",
      title: "Why are you reporting this skit?",
      subtitle:
        "If someone is in immediate danger, get help before reporting. Don't wait.",
      options: [
        {
          id: "under18",
          label: "Problem involving someone under 18",
          next: "under18Details",
        },
        {
          id: "bullying",
          label: "Bullying, harassment or abuse",
          next: "bullyingDetails",
        },
        {
          id: "selfharm",
          label: "Suicide or self-harm",
          next: "selfharmDetails",
        },
        {
          id: "violent",
          label: "Violent, hateful or disturbing content",
          next: "violentDetails",
        },
        {
          id: "restricted",
          label: "Selling or promoting restricted items",
          next: "summary",
        },
        { id: "adult", label: "Adult content", next: "adultDetails" },
        {
          id: "scam",
          label: "Scam, fraud or false information",
          next: "summary",
        },
        { id: "ip", label: "Intellectual property", next: "ipDetails" },
        { id: "hide", label: "I don't want to see this", next: "summary" },
      ],
    },
    // Under-18 submenu
    {
      id: "under18Details",
      type: "list",
      title: "Which best describes the problem?",
      options: [
        {
          id: "threatNudes",
          label: "Threatening to share my nude images",
          next: "summary",
        },
        {
          id: "sexualExploitation",
          label: "Seems like sexual exploitation",
          next: "summary",
        },
        {
          id: "sharingNudes",
          label: "Sharing someone’s nude images",
          next: "summary",
        },
        {
          id: "generalBullying",
          label: "Bullying or harassment",
          next: "summary",
        },
        { id: "physicalAbuse", label: "Physical abuse", next: "summary" },
      ],
    },
    // Bullying submenu (identical to under18Details)
    {
      id: "bullyingDetails",
      type: "list",
      title: "Which best describes the problem?",
      options: [
        {
          id: "threatNudes",
          label: "Threatening to share my nude images",
          next: "summary",
        },
        {
          id: "sexualExploitation",
          label: "Seems like sexual exploitation",
          next: "summary",
        },
        {
          id: "sharingNudes",
          label: "Sharing someone’s nude images",
          next: "summary",
        },
        {
          id: "generalBullying",
          label: "Bullying or harassment",
          next: "summary",
        },
        { id: "physicalAbuse", label: "Physical abuse", next: "summary" },
      ],
    },
    // Self-harm submenu
    {
      id: "selfharmDetails",
      type: "list",
      title: "What kind of self-harm?",
      options: [
        { id: "suicideInjury", label: "Suicide or self-injury", next: "summary" },
        { id: "eatingDisorder", label: "Eating disorder", next: "summary" },
      ],
    },
    // Violent submenu
    {
      id: "violentDetails",
      type: "list",
      title: "How is it violent, hateful or disturbing?",
      options: [
        {
          id: "threatToSafety",
          label: "Credible threat to safety",
          next: "summary",
        },
        { id: "terrorism", label: "Seems like terrorism", next: "summary" },
        { id: "callForViolence", label: "Calling for violence", next: "summary" },
        {
          id: "organizedCrime",
          label: "Seems like organised crime",
          next: "summary",
        },
        { id: "promotingHate", label: "Promoting hate", next: "hateDetails" },
        {
          id: "graphicViolence",
          label: "Showing violence, death or severe injury",
          next: "summary",
        },
        { id: "animalAbuse", label: "Animal abuse", next: "summary" },
      ],
    },
    // Hate submenu
    {
      id: "hateDetails",
      type: "list",
      title: "How does it promote hate?",
      options: [
        {
          id: "organizedHateGroup",
          label: "It represents an organised hate group",
          next: "summary",
        },
        { id: "speech", label: "Posting hateful speech", next: "summary" },
      ],
    },
    // Adult submenu
    {
      id: "adultDetails",
      type: "list",
      title: "How is it adult content?",
      options: [
        {
          id: "threatNudes",
          label: "Threatening to share my nude images",
          next: "summary",
        },
        { id: "prostitution", label: "Seems like prostitution", next: "summary" },
        {
          id: "sharedNudes",
          label: "My nude images have been shared",
          next: "summary",
        },
        {
          id: "sexualExploitation",
          label: "Seems like sexual exploitation",
          next: "summary",
        },
        { id: "nudity", label: "Nudity or sexual activity", next: "summary" },
      ],
    },
    // Intellectual property free-text
    {
      id: "ipDetails",
      type: "input",
      title: "What about this i.p. are you reporting?",
      subtitle: "E.g. “Copyright infringement for a song,” “Trademark misuse.”",
    },
    // Final summary
    {
      id: "summary",
      type: "summary",
      title: "Review your report",    
      subtitle:
        "We only remove content that goes against our Community Standards.",
    },
  ];
  